(ns frontend.view.settings2.e-signature.events
  (:require
   [frontend.actions.tenant :as tenant-actions]
   [frontend.view.settings2.e-signature.sub :as sub]
   [re-frame.core :as rf]
   [clojure.set :as set]
   [frontend.state.current-session :as session]
   [cljs-uuid-utils.core :as uuid]
   [ui.util :as uu]))

(rf/reg-event-fx
 ::set-all-credentials
 (fn [{db :db} [_ credentials]]
   {:db (assoc db ::sub/credentials credentials)}))

(rf/reg-event-fx
 ::set-edited-credential-field
 (fn [{db :db} [_ i field value]]
   {:db (assoc-in db [::sub/edited-credential field] value)}))

(rf/reg-event-fx
 ::set-target-entity-type
 (fn [{db :db} [_ value]]
   {:db (assoc db ::sub/target-entity-type value)}))

(rf/reg-event-fx
 ::set-target-entity-id
 (fn [{db :db} [_ value]]
   {:db (assoc db ::sub/target-entity-id value)}))

(rf/reg-event-fx
 ::add-target
 (fn [{:keys [db] :as cofx} [_]]
   (let [target-entity-id (::sub/target-entity-id db)
         target-entity-type (::sub/target-entity-type db)
         new-target (merge
                     {:entity/type target-entity-type}
                     (when (and (= :entity.type/pipeline target-entity-type) target-entity-id)
                       {:db/id target-entity-id}))]
     {:db (-> db
              (update-in [::sub/edited-credential :targets] concat [new-target]))})))

(rf/reg-event-fx
 ::set-target-input-visible
 (fn [{db :db} [_ visible?]]
   {:db (assoc db ::sub/target-input-visible? visible?)}))

(rf/reg-event-db
 ::set-provider
 (fn [db [_ provider]]
   (assoc db ::sub/selected-provider provider)))

(rf/reg-event-fx
 ::set-target-field
 (fn [{:keys [db] :as cofx} [_ i field value]]
   {:db (-> db
            (assoc-in [::sub/edited-credential :targets i field] value))}))

(defn remove-at
  [coll i]
  (-> i
      (take coll)
      (concat (drop (inc i) coll))
      vec))

(rf/reg-event-fx
 ::remove-target
 (fn [{db :db} [_ i]]
   {:db (update-in db [::sub/edited-credential :targets] remove-at i)}))

(rf/reg-event-fx
 ::save-all-credentials
 (fn [{db :db} [_]]
   (let [edited-credential-index (or (::sub/edited-credential-index db)
                                     (-> db
                                         ::sub/credentials
                                         (count)))
         credentials (::sub/credentials db)
         edited-credential (when (::sub/edited-credential db)
                             (-> db
                                 ::sub/edited-credential
                                 (assoc :provider (::sub/selected-provider db))
                                 (update :webhook-id
                                         (->> (uuid/make-random-uuid)
                                              (uuid/uuid-string)
                                              (fnil identity)))))
         edited-credentials (if (nil? edited-credential)
                              credentials
                              (-> credentials
                                  (vec)
                                  (assoc edited-credential-index edited-credential)))]
     (tenant-actions/*->update! @session/tenant-id
                                :tenant/esign-api-credentials
                                (pr-str edited-credentials)
                                (fn []
                                  (js/console.log "Oneflow credentials saved"))
                                (fn []
                                  (js/console.log "Failed to save Oneflow credentials")))
     {:db (-> db
              (dissoc ::sub/edited-credential)
              (dissoc ::sub/edited-credential-index)
              (assoc ::sub/credentials edited-credentials))})))

(rf/reg-event-fx
 ::remove-credentials
 (fn [{db :db} [_ index]]
   {:db       (update db ::sub/credentials remove-at index)
    :dispatch [::save-all-credentials]}))

(rf/reg-event-fx
 ::show-token
 (fn [{db :db} [_ row-index]]
   {:db (update db ::sub/visible-token-rows set/union #{row-index})}))

(rf/reg-event-fx
 ::hide-token
 (fn [{db :db} [_ row-index]]
   {:db (update db ::sub/visible-token-rows set/difference #{row-index})}))

(rf/reg-cofx
 ::create-webhook-id-and-oneflow-sign-key
 (fn [cofx]
   (let [{:keys [add-new? provider]} (-> cofx
                                         :original-event
                                         second)]
     (if add-new?
       (cond-> cofx
         true (assoc :webhook-id (uu/make-uuid))
         (= provider :oneflow) (assoc :webhook-sign-key (uu/make-uuid)))
       cofx))))

(rf/reg-event-fx
 ::set-edited-credential
 [rf/trim-v
  (rf/inject-cofx ::create-webhook-id-and-oneflow-sign-key)]
 (fn [{:keys [db webhook-id webhook-sign-key] :as _cofx}
      [{:keys [credential provider add-new?]}]]
   (let [credential (if add-new?
                      (cond-> {}
                        true (assoc :webhook-id webhook-id)
                        (= provider :oneflow) (assoc :webhook-sign-key webhook-sign-key))
                      credential)]
     {:db (assoc db ::sub/edited-credential credential)})))

(rf/reg-event-fx
 ::set-edited-credential-index
 (fn [{db :db} [_ index]]
   {:db (assoc db ::sub/edited-credential-index index)}))
